import {useState,useEffect,useRef} from 'react'; 
import  Bredcrum  from '../../components/bredcrum';
import { Tag } from 'primereact/tag';
import {Tablescom} from '../../components/tablescomp';
import { Toast } from 'primereact/toast';

import {userservices} from '../../services/userServices';
import {productservices} from '../../services/productServices';
import {Titlebar,Searchbox,Label} from  '../../components/fieldsComp';
import { useSelector } from 'react-redux';
import {  useParams } from "react-router";
import { Formik, Field, Form } from 'formik';
const Productedit = () =>{

    const unitreducer = useSelector((state)=>state.unitreducer);
    const {id} = useParams();

    const [users,setUsers] = useState([]);
    const [units,setUnits] = useState([]);
    const [results,setResults] = useState([]);
    const [userloaded,setUserloaded] = useState(true);
    const toast = useRef(null);
    const [categorydata, setCatergorydata] = useState([]);

    const [rows, setRows] = useState([]);
    
    const [formData, setFormData] = useState({
        id:'',
        product_name: '',
        sku_code: '',
        components:[],
        units:[],
        quantity:[],
        // 'finished' or 'component'
    });

    const handleAddRow = () => {
        setRows([...rows, { id: Date.now(), quantity: 0 }]);
    };

    const handleRemoveRow = (index) => {
        const newRows = [...rows];
        newRows.splice(index, 1);
        setRows(newRows);
    };  
        useEffect(()=>{
            getspecificproduct(id);
            getcomponents();
            getunits();
            getCategoryData();
        },[]); 


        const getCategoryData = () =>{
                productservices.getcategory().then((response) => {
                    if(response.status == 200){
                        setCatergorydata(response.data.data);
                    }
                }).catch((error) => {
                    console.log("error : ", error);
                });
            }

        

        const handleChange = (e) => {
            setFormData({
            ...formData,
            [e.target.name]: e.target.value,
            });
        };

        const handleSave = (values) => {
            // console.log('Form Data:', values);
            // return;
            // Add your save logic here
            productservices.editproduct(values).then((response)=>{
                console.log(response);
                 if(response.status == 200){
                    //  console.log€0
                    toast.current.show({ severity: 'success', summary: 'Product', detail: 'Product added successfully' }); 
                 }else{
                    toast.current.show({ severity: 'error', summary: 'Product', detail: `${response.data.data}` }); 
                 }   
            }).catch((error)=>{
                toast.current.show({ severity: 'error', summary: 'Product', detail: 'Error' }); 
            });
        };

        const handleClose = () => {
            console.log('Form Closed');
        };

        const getspecificproduct  = (id)=> {
                // setUserloaded(false);
                productservices.editproductdetail(id).then((response)=>{
                    if(response.status == 200){
                        console.log("Get Specific product");
                        console.log(response.data.data.components);
                        setFormData(response.data.data);
                        setRows(response.data.data.components);
                    }else{
                    }  
                }).catch((error)=>{
                }); 
        } 


        const getcomponents  = ()=> {
            setUserloaded(false);
            productservices.getcomponents().then((response)=>{
                if(response.status == 200){
                //   console.log(response.data.data);
                setResults(response.data.data);
                setUserloaded(true);
                }else{
                setUsers([]);
                setUserloaded(true);
                }  
            }).catch((error)=>{
                setResults([]);
                setUserloaded(true);
            }); 
        } 


        const getunits = () =>{
            let temparr = [];
            unitreducer.then((response)=>{
                setUnits(response);
            }).catch((error)=>{
            });
        }

        const displayunits = () =>{
            let temparr = [];
            units.forEach((value,index)=>{
                temparr.push(<option value={value.short_code}>{value.name}</option>)     
            });
            return temparr; 
        }

        const displayData = () =>{
            let temparr = [];
            results.forEach((value,index)=>{
            temparr.push(<option value={value.id}><span>Component : {value.component}</span> Sku : {value.componentSkuCode}</option>)   
            })    
            return temparr;
        }
  
  return(
       <>
          <Toast ref={toast} /> 
          <Bredcrum title={'Product / editproduct'} divider={false}/>
          <div class="row">
              {/* <div className='col-md-12 mb-4 mt-4'>
                 <div className='flex-box flex-between'>
                      <button className='btn btn-primary rounded-pill custom-btn-color custom-btn-br-color custom-btn-style'>Add New Product</button> 
                      <Searchbox/>
                  </div> 
              </div>  */}
             
              
              {/* <Titlebar text={'Edit Product'}/> */}
              <div className="col-md-12 mt-3">
                  <div className='card ps-3 pe-3'>
                    <div className='card-body card-body-style'>
                         
                         <div className='row'>
                         <div className="container mt-4">
                         <Formik
                                initialValues={formData}
                                enableReinitialize={true}
                                onSubmit={async (values) => {
                                    // console.log("values data");
                                    // console.log(values);
                                    handleSave(values);
                                    // await new Promise((r) => setTimeout(r, 500));
                                    // alert(JSON.stringify(values, null, 2));
                                }}
                                >
                                <Form>
                                 
                                <div className="row">
                                    <div className="col-md-6 form-group">
                                    <Label name="Product Name" />
                                    <Field type="text"  name="product_name" className="form-control"
                                        placeholder="Enter Product Name" required/>
                                    </div>

                                    <div className="col-md-6 form-group">
                                    <Label name="Master SKU Code" />
                                    <Field type="text" name="sku_code" className="form-control"
                                        placeholder="Enter Master SKU Code" required/>
                                    </div>

                                    <div className="col-md-6 form-group">
                                        <Label name="Stock Type" />
                                        <Field as="select" name="stock_type" className="form-control"
                                            placeholder="Stock Type" required >
                                                <option value="">Select Stock type</option>  
                                                <option value="finished">Finished</option> 
                                                <option value="unfinished">UnFinished</option>   
                                        </Field>
                                    </div>

                                    <div className="col-md-6 form-group">
                                        <Label name="Product Img" />
                                        <Field type="file" name="file" className="form-control"
                                        accept="image/*"
                                            placeholder="Product Image"/>
                                    </div>

                                    <div className="col-md-6 form-group">
                                        <label name="Notes" >Notes</label>
                                        <Field as="textarea" name="notes" className="form-control"
                                        placeholder="Enter Notes"/>
                                    </div>
                                    <div className="col-md-6 form-group">
                                                    <Label name="Product Category" />
                                                    <Field as="select" name="category_id" className="form-control"
                                                        placeholder="Stock Type" >
                                                            <option  value=''>Select category</option>
                                                             {categorydata.map((ele) => {
                                                                    return (
                                                                        <>
                                                                            <option key={ele.id} value={ele.id}>{ele.category_name}</option>
                                                                        </>
                                                                    )
                                                                })}
                                                    </Field>
                                                </div>

                                </div>

                                <br></br>
                             
                                <div className="row">
                                    <div className='col-md-6'>
                                    <button
                                    type="submit"
                                    className="btn color-white me-2 w-100 rounded custom-btn-br-color custom-btn-color"
                                    
                                    >
                                    Save
                                    </button>
                                    </div>

                                    <div className='col-md-6'>
                                    <button
                                    type="button"
                                    className="btn color-white w-100 rounded custom-btn-color-secondary"
                                    onClick={handleClose}
                                    >
                                    Close
                                    </button>
                                    </div>
                                </div>
                                </Form>
                                
                                </Formik>
                         {/* <form>
                                <div className="row">
                                    <div className="col-md-6 form-group">
                                    <Label name="Product Name" />
                                    <input
                                        type="text"
                                        name="product_name"
                                        className="form-control"
                                        placeholder="Enter Product Name"
                                        value={formData.product_name}
                                        onChange={handleChange}
                                    />
                                    </div>

                                    <div className="col-md-6 form-group">
                                    <Label name="SKU Code" />
                                    <input
                                        type="text"
                                        name="sku_code"
                                        className="form-control"
                                        placeholder="Enter Master SKU Code"
                                        value={formData.sku_code}
                                        onChange={handleChange}
                                    />
                                    </div>

                                    <div className="col-md-6 form-group">
                                    <Label name="Stock On Hand" />
                                    <input
                                        type="number"
                                        name="stock_on_hand"
                                        className="form-control"
                                        placeholder="Enter the number of units in your inventory"
                                        value={formData.stock_on_hand}
                                        onChange={handleChange}
                                    />
                                    </div>

                                    <div className="col-md-6 form-group">
                                    <Label name="Stock Needed" />
                                    <input
                                        type="number"
                                        name="stock_needed"
                                        className="form-control"
                                        placeholder="Enter Stock Needed"
                                        value={formData.stock_needed}
                                        onChange={handleChange}
                                    />
                                    </div>

                                    <div className="col-md-6 form-group">
                                    <Label name="Discrepancy Alert" />
                                    <select
                                        name="discrepancy_alert"
                                        className="form-control"
                                        value={formData.discrepancy_alert}
                                        onChange={handleChange}
                                    >
                                        <option value="">Select Discrepancy Status</option>
                                        <option value={1}>Yes</option>
                                        <option value={0}>No</option>
                                    </select>
                                    </div>

                                    <div className="col-md-6 form-group">
                                    <Label name="Restock Alert Threshold" />
                                    <input
                                        type="number"
                                        name="restock_alert_threshold"
                                        className="form-control"
                                        placeholder="Enter Restock Alert Threshold"
                                        value={formData.restock_alert_threshold}
                                        onChange={handleChange}
                                    />
                                    </div>

                                    <div className="col-md-6 form-group">
                                    <Label name="Stock Location" />
                                    <input
                                        type="text"
                                        name="stock_location"
                                        className="form-control"
                                        placeholder="Enter Stock Location"
                                        value={formData.stock_location}
                                        onChange={handleChange}
                                    />
                                    </div>

                                    <div className="col-md-6 form-group">
                                    <Label name="Stock Type" />
                                    <select
                                        name="stock_type"
                                        className="form-control"
                                        value={formData.stock_type}
                                        onChange={handleChange}
                                    >
                                        <option value="">Select Stock Type</option>
                                        <option value="finished">Finished</option>
                                        <option value="component">Component</option>
                                    </select>
                                    </div>
                                </div>
                                <br></br>
                                <br></br>
                                <div className="row">
                                    <div className='col-md-6'>
                                    <button
                                    type="button"
                                    className="btn color-white me-2 w-100 rounded custom-btn-br-color custom-btn-color"
                                    onClick={handleSave}
                                    >
                                    Save
                                    </button>
                                    </div>

                                    <div className='col-md-6'>
                                    <button
                                    type="button"
                                    className="btn color-white w-100 rounded custom-btn-color-secondary"
                                    onClick={handleClose}
                                    >
                                    Close
                                    </button>
                                    </div>
                                </div>
                                </form> */}

                                </div>

                         </div>
                     </div>
                 </div>
              </div>   
          </div>
       </>
    );   
 }
 export default Productedit;